var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import Component from 'vue-class-component/lib';
import { Prop } from 'vue-property-decorator';
import CommonService from "../../../api/CommonService";
import CACHE_KEY from "../../../constant/cacheKey";
import RootType from "../../../store/mutation-types";
import { CachePocily } from "../../../common/Cache";
import { ECache } from "../../../enum/ECache";
import { Loading } from 'element-ui';
import router from "../../../router";
var phoneCodeDialog = (function (_super) {
    __extends(phoneCodeDialog, _super);
    function phoneCodeDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = CachePocily.getInstance(ECache.LocCache);
        _this.verifyCode = '';
        _this.canGetCode = false;
        _this.remainSeconds = 60;
        _this.timer = null;
        _this.dialogVisible = false;
        _this.isValid = false;
        return _this;
    }
    phoneCodeDialog.prototype.created = function () {
        this.commonService = CommonService.getInstance();
    };
    phoneCodeDialog.prototype.show = function () {
        this.isValid = false;
        this.dialogVisible = true;
    };
    phoneCodeDialog.prototype.close = function () {
        this.dialogVisible = false;
        this.isValid = false;
        this.verifyCode = '';
    };
    phoneCodeDialog.prototype.timerDown = function () {
        var _this = this;
        this.timer = setInterval(function () {
            _this.remainSeconds--;
            if (_this.remainSeconds === 0) {
                _this.clearTimer();
            }
        }, 1000);
    };
    phoneCodeDialog.prototype.clearTimer = function () {
        clearInterval(this.timer);
        this.timer = null;
        this.remainSeconds = 60;
        this.canGetCode = true;
    };
    phoneCodeDialog.prototype.isValidCode = function (code) {
        var codePattern = /^[0-9]{6}$/;
        return codePattern.test(code);
    };
    phoneCodeDialog.prototype.sendCode = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            var _this = this;
            return __generator(this, function (_a) {
                if (this.timer)
                    return [2];
                params = {
                    phone: this.phone,
                    type: this.codeType
                };
                this.commonService.sendCode(params).then(function (res) {
                    _this.$message.success('发送成功！');
                }, function (error) {
                    _this.$message.error(error.message);
                });
                this.canGetCode = false;
                this.timerDown();
                return [2];
            });
        });
    };
    phoneCodeDialog.prototype.save = function () {
        var _this = this;
        if (!this.isValidCode(this.verifyCode)) {
            this.$message.error('请输入6位纯数字验证码');
            return;
        }
        var loadingInstance = Loading.service({
            text: '账号注销中，请稍后！'
        });
        var postData = {
            smscode: this.verifyCode,
        };
        console.log("~ 🚀 GZY-日志起飞 ~ postdata", postData);
        this.commonService.getDestroyAll(postData).then(function (res) {
            _this.clearTimer();
            _this.close();
            var data = res.data;
            loadingInstance.close();
            if (data.code === 0) {
                _this.$message.success('账号注销成功！');
                _this.cache.remove(CACHE_KEY.LOGIN);
                _this.$store.commit(RootType.UPDATE_LOGINMODEL, null);
                router.push('/');
            }
            else {
                _this.$emit('destroy', data);
            }
        }, function (error) {
            loadingInstance.close();
            _this.$message.error(error.message);
        });
    };
    phoneCodeDialog.prototype.onInput = function (value) {
        var numericValue = value.replace(/\D/g, '');
        if (numericValue.length > 6) {
            numericValue = numericValue.slice(0, 6);
        }
        this.isValid = numericValue.length < 6;
        this.verifyCode = numericValue;
    };
    __decorate([
        Prop({
            type: String,
            default: ''
        })
    ], phoneCodeDialog.prototype, "phone", void 0);
    __decorate([
        Prop({
            type: String,
            default: ''
        })
    ], phoneCodeDialog.prototype, "accountName", void 0);
    __decorate([
        Prop({
            type: String,
            default: ''
        })
    ], phoneCodeDialog.prototype, "dialogTitle", void 0);
    __decorate([
        Prop({
            type: Number,
            default: null
        })
    ], phoneCodeDialog.prototype, "codeType", void 0);
    phoneCodeDialog = __decorate([
        Component({})
    ], phoneCodeDialog);
    return phoneCodeDialog;
}(Vue));
export default phoneCodeDialog;
